import { Status } from '@lct-jobs/core';

export const FAILED_JOB_STATUSES: ReadonlySet<Status> = new Set([
  Status.FAILED,
  Status.INVALID_PROVIDER_RESPONSE,
  Status.INTERNAL_ERROR,
  Status.CANCELLATION_FAILED,
  Status.EXECUTION_TIMEOUT,
  Status.QUEUE_TIMEOUT,
]);
